<section class="surface">
	@if (viewUser() && !editingShare()) {
		@if (canAccessUserManagement()) {
			<lvr-nav-carousel [backLink]="backLink()" [carouselElements]="carouselElements()" [showCarousel]="false">
			</lvr-nav-carousel>
		}

		<lvr-heading [showEditButton]="canEditUsers()" (editClicked)="openEdit()">
			{{ 'user.user_view.title' | transloco }}
		</lvr-heading>

		<!-- User Details -->
		<lvr-admin-user-view
			[user]="viewUser()"
			[userGender]="userGender()"
			[canReadPositionShareDetails]="canReadPositionShares()"
		></lvr-admin-user-view>

		@if (canReadPositionShares()) {
			<!-- Position share list -->
			<lvr-position-share-list
				[userId]="+viewUser().id"
				[canEditPositionShares]="canEditPositionShares()"
				(editShare)="onEditShare($event)"
			>
			</lvr-position-share-list>
		}
	}

	<!-- Edit Position Share -->
	@if (editingShare() && canEditPositionShares()) {
		<lvr-position-share-edit
			class="mt-4"
			[positionShare]="editingShare()"
			(shareSaved)="onShareSaved($event)"
			(shareCancel)="onShareCancel()"
		>
		</lvr-position-share-edit>
	}

	@if (!viewUser()) {
		<div class="no-user">
			<p>{{ 'user.table.no_entries' | transloco }}</p>
		</div>
	}
</section>
